import Wiki from './components/wiki';
import GnarlyDataWaves from './pages/gnarly-data-waves';
import StickyAnchorMenu from './blocks/sticky-anchor-menu';
import ready, { HTML } from './utils';


ready(() => {
    Wiki.init();
    GnarlyDataWaves.init();
    StickyAnchorMenu.init();
});